import { TabContext, TabList } from '@mui/lab'
import { Box, Button, CircularProgress, Container, Dialog, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useRef } from 'react'
import { GET_GST_MATCH_DATA, GET_MATCH_REVENUE, GET_PRED_WISE_DATA, GET_PRO_PLAY_RUN_WISE_DATA } from '../constant/endpoint';
import moment from 'moment';
import Swal from 'sweetalert2';
import { useStyles } from '../constant/constant';
import { mkConfig, generateCsv, download } from "export-to-csv";
import { SlArrowLeftCircle } from 'react-icons/sl'



// Match data provided here

export default function FinishedPredictionGst() {

    const startDate = useRef()
    const endDate = useRef()
    const [value, setValue] = React.useState('1');
    const [detailDialog, setDetailDialog] = React.useState(false);
    const [predDetailDialog, setPredDetailDialog] = React.useState(false);
    const [runWiseDialog, setRunWiseDialog] = React.useState(false);
    const [predictionInfo, setPredictionInfo] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    // const [defaultPage, setDefaultPage] = React.useState(1)
    const [data, setData] = React.useState([])
    const [insidePreData, setInsidePreData] = React.useState([])
    const [revenue, setRevenue] = React.useState([])
    const [predWiseData, setPredWiseData] = React.useState([])
    const [runWiseData, setRunWiseData] = React.useState([])
    const [tradePage, setTradePage] = React.useState(1);
    const [password, setPassword] = React.useState(false)

    const classes = useStyles();
    const handleChange = (event, newValue,page) => {
        // Swal.fire({
        //     title: 'Provide The Passwords',
        //     input: 'password',
        //     showCancelButton: true,
        //     confirmButtonText: 'Show Data',
        //     showLoaderOnConfirm: true,
        //     preConfirm: (text) => {
        //         if (text === '') {
                    setValue(newValue)
                    getMatchData(Number(newValue) + 2, startDate.current.value, endDate.current.value, page ? page : tradePage)
        //         }
        //     }
        // })

    };

    const getMatchData = async (type = 3, startDate, endDate, page, isPassword) => {
        if (!password && !isPassword) {
            Swal.fire({
                title: 'Provide The Passwords',
                input: 'password',
                showCancelButton: true,
                confirmButtonText: 'Show Data',
                showLoaderOnConfirm: true,
                position: 'center',
                preConfirm: async(text) => {
                    if (text === 'youKnowMe') {
                        setPassword(true)
                        const result = await axios.get(`${GET_GST_MATCH_DATA.replace(':type', type)}?start_date=${startDate}&end_date=${endDate}&page=${page}`)
                             if (result.data.status === 'success') {
                             setData(result.data.data)
            }
                    }
                    else {
                        Swal.showValidationMessage('Incorrect password');
                    }
                }
            })
        }
        else {
            const result = await axios.get(`${GET_GST_MATCH_DATA.replace(':type', type)}?start_date=${startDate}&end_date=${endDate}&page=${page}`)
            if (result.data.status === 'success') {
                setData(result.data.data)
            }
        }
    }

    const showMatchDetails = async (data) => {
        setRevenue([])
        setDetailDialog(true)
        setInsidePreData(data)
        setLoading(true)
        const result = await axios.get(`${GET_MATCH_REVENUE.replace(':type', Number(value) + 2)}?match_id=${data.match_id}&sport=${data.matchData[0].sport}`)
        if (result.data.status === 'success') {
            setRevenue(result.data.data)
        }
        setLoading(false)

    }

    const showPredWiseData = async (data) => {
        setPredDetailDialog(true)
        setLoading(true)
        const result = await axios.get(`${GET_PRED_WISE_DATA.replace(':type', Number(value) + 2)}?match_id=${data.match_id}&sport=${data.matchData[0].sport}`)
        if (result.data.status === 'success') {
            setPredWiseData(result.data.data)
        }
        setLoading(false)

    }

    const handlePagination = async (page) => {
        setTradePage(page)
        handleSubmit("",  page)
    }

    const handleSubmit = (e, page) => {
        if (e) {
            e.preventDefault()
            // Swal.fire({
            //     title: 'Provide The Passwords',
            //     input: 'password',
            //     showCancelButton: true,
            //     confirmButtonText: 'Show Data',
            //     showLoaderOnConfirm: true,
            //     preConfirm: (text) => {
            //         if (text === 'youKnowMe') {
            //             // setValue(newValue)
            //             setTradePage(1)
            //             // getMatchData(Number(newValue) + 2, startDate.current.value, endDate.current.value, page ? page : tradePage)
            //             handleChange('event', value, 1)
            //         }
            //     }
            // })

            setTradePage(1)
            handleChange('event', value, 1)
        }
        else {
            handleChange('event', value, page)
        }
        
    }

    const downloadCSV = async () => {
        let csvData = []
        const result = await axios.get(`${GET_GST_MATCH_DATA.replace(':type', Number(value) + 2)}?start_date=${startDate.current.value}&end_date=${endDate.current.value}&page=${tradePage}&exportAll=true`)
        if (result.data.status !== 'success' || !result.data.data || !result.data.data.length) {
            return;
        }
        csvData = result.data.data

        Swal.fire({
            title: 'Provide The Passwords',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Show Data',
            showLoaderOnConfirm: true,
            preConfirm: (text) => {
                if (text === 'youKnowMe') {
                    const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: "Match Data" });
                    const csvParsedData = parseCSVData(csvData)
                    const csv = generateCsv(csvConfig)(csvParsedData);
                    download(csvConfig)(csv);
                }
            }
        })



    }

    const parseCSVData = (csvData) => {
        let temp = []

            // setData(result.data.data)
            let matchData = csvData;
            matchData.map((input) => {
                temp.push({
                    "Match Id": input?.match_id,
                    "Match Name": input?.matchData[0]?.localteam + ' vs ' + input?.matchData[0]?.visitorteam,
                    "Time": moment(input?.matchData[0]?.time)?.format('DD/MM/YYYY, h:mm A'),
                    "Profit": input?.profit?.toFixed(2),
                    "Total Incoming": input?.total_incoming,
                    "Total Outgoing": input?.total_outgoing
                })
            })
            return temp;

       
    }

    const downloadCSVPredWise = async () => {
        if (!predWiseData || !predWiseData.length) {
            return;
        }
        Swal.fire({
            title: 'Provide The Passwords',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Show Data',
            showLoaderOnConfirm: true,
            position: 'top-end',
            preConfirm: (text) => {
                if (text === 'youKnowMe') {

                    const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: `MatchDataPredWise` });
                    const csvParsedData = parseCSVPRedWiseData()
                    const csv = generateCsv(csvConfig)(csvParsedData);
                    download(csvConfig)(csv);
                }
            }
        })

    }
    const parseCSVPRedWiseData = () => {
        let temp = []
        let matchData = predWiseData;
        matchData.map((input) => {
            temp.push({
                "Prediction ID": input._id,
                "Question": input.question_english,
                "Profit": input?.profit?.toFixed(2),

            })
        })
        return temp;
    }

    const proPlayRunWiseData = async (predData) => {
        setRunWiseDialog(true)
        setPredictionInfo(predData)
        setLoading(true)
        const result = await axios.get(`${GET_PRO_PLAY_RUN_WISE_DATA}?prediction_id=${predData._id}`)
        if (result.data.status === 'success') {
            setRunWiseData(result.data.data)
        }
        setLoading(false)
    }
    const downloadCSVRunWise = async () => {
        console.log("hh", runWiseData);
        if (!runWiseData || !runWiseData.length) {
            return;
        }

        Swal.fire({
            title: 'Provide The Passwords',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Show Data',
            showLoaderOnConfirm: true,
            position: 'top-end',
            preConfirm: (text) => {
                if (text === 'youKnowMe') {
                    const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: `PredictionDataRunWise_${predictionInfo._id}` });
        const csvParsedData = parseCSVRunWiseData()
        const csv = generateCsv(csvConfig)(csvParsedData);
        download(csvConfig)(csv);
                }
            }
        })
      

    }

    const parseCSVRunWiseData = () => {
        let temp = []
        let matchData = runWiseData;
        matchData.map((input) => {
            temp.push({
                "Prediction Id": predictionInfo._id,
                "Option Id": input._id.option_id,
                "Runs": input._id._id,
                "Total Slot": input?.total_slot,

            })
        })
        return temp;
    }

    useEffect(() => {
        if (password === false) {
            
            Swal.fire({
                title: 'Provide The Passwords',
                input: 'password',
                showCancelButton: true,
                confirmButtonText: 'Show Data',
                showLoaderOnConfirm: true,
                position: 'center',
                preConfirm: (text) => {
                    if (text === 'youKnowMe') {
                        setPassword(true)
                        getMatchData(3, startDate.current.value, endDate.current.value, tradePage, true)
                    }else {
                        Swal.showValidationMessage('Incorrect password');
                    }
                }
            })


        }
    })
    return (
        <div>
            <Box sx={{ width: '100%', typography: 'body1' }} style={{ marginTop: "100px" }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example" style={{ display: "flex !important", justifyContent: "space-around !important" }} >
                            {
                                ['Trading', 'QUIZ PLAY', 'Skiller'].map((data, index) =>
                                    <Tab label={data === 'running' ? 'Live' : data === 'cancelled' ? 'Result Pending' : data === 'completed' ? 'Result' : data} key={index} value={(index + 1).toString()} title={(index + 1).toString()} />
                                )
                            }
                        </TabList>
                    </Box>
                </TabContext>
                <div style={{ margin: '20px' }}>
                    <form onSubmit={handleSubmit} style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                            <label style={{ fontSize: '18px', marginBottom: '5px' }} htmlFor="startDate">Start Date:</label>
                            <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                ref={startDate}
                                style={{
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '16px',
                                    width: '100%',
                                    maxWidth: '300px', // Adjust the width as needed
                                }}
                            />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                            <label style={{ fontSize: '18px', marginBottom: '5px' }} htmlFor="endDate">End Date:</label>
                            <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                ref={endDate}
                                style={{
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '16px',
                                    width: '100%',
                                    maxWidth: '300px', // Adjust the width as needed
                                }}
                            />
                        </div>

                        <button
                            type="submit"
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '18px',
                                cursor: 'pointer',
                            }}
                        >
                            Search
                        </button>

                        <div
                            onClick={() => downloadCSV()}

                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '18px',
                                cursor: 'pointer',
                            }}
                        >
                            Download CSV
                        </div>

                    </form>
                </div>

                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                    <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Match Id</TableCell>
                                <TableCell align="center">Match Name</TableCell>
                                <TableCell align="center">Time Date</TableCell>
                                <TableCell align="center">Profit</TableCell>
                                <TableCell align="center">Details</TableCell>
                                <TableCell align="center">Prediction Details</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map(preData => <TableRow key={preData.match_id}>
                                <TableCell align='center'>{preData.match_id}</TableCell>
                                <TableCell align='center'>{preData.matchData[0]?.localteam + 'vs' + preData.matchData[0]?.visitorteam}</TableCell>
                                <TableCell align='center'>{moment(preData.createdAt).format('DD/MM/YYYY, h:mm A')}</TableCell>
                                <TableCell align='center'>{preData.profit.toFixed(2)}</TableCell>
                                <TableCell align='center'><Button variant='contained' color={'secondary'} size="small" onClick={() => showMatchDetails(preData)}>Details</Button></TableCell>
                                <TableCell align='center'><Button variant='contained' color={'secondary'} size="small" onClick={() => showPredWiseData(preData)}>Show</Button></TableCell>
                            </TableRow>)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <MatchDetails detailDialog={detailDialog} setDetailDialog={setDetailDialog} insidePreData={insidePreData} revenue={revenue} value={value} loading={loading}></MatchDetails>
            <PredWiseDetails predDetailDialog={predDetailDialog} setPredDetailDialog={setPredDetailDialog} predWiseData={predWiseData} value={value} loading={loading} downloadCSVPredWise={downloadCSVPredWise} proPlayRunWiseData={proPlayRunWiseData}
                
            ></PredWiseDetails>
            <ProPlayRunWiseData value={value} loading={loading} runWiseData={runWiseData} runWiseDialog={runWiseDialog} setRunWiseDialog={setRunWiseDialog} predictionInfo={predictionInfo} downloadCSVRunWise={downloadCSVRunWise} ></ProPlayRunWiseData>
            
            <Container spacing={2}  style={{paddingBottom:"20px"}}>
                        {
                                            data.length > 0 &&
                                            <div style={{display:"flex", justifyContent:"end"}}>
                                                    {
                                                        tradePage > 1 ? <span style={{color:"#0288d1", cursor:"pointer", fontWeight:"bolder", fontSize:"20px"}} onClick={()=> handlePagination(tradePage -1)}> {"<"} </span> : ""
                                                    } 
                                                    <span  style={{fontSize:"20px", padding:"0px 4px"}}>{tradePage}</span>
                                                    {
                                                         data.length == 20 ?
                                                         <span style={{ color:"#0288d1", cursor:"pointer",  fontWeight:"bolder", fontSize:"20px"}} onClick={() => handlePagination(tradePage + 1)}> {">"}
                                                            </span>
                                                            : ""
                                                    }
                                            </div>
                        }
                                 </Container>

        </div>
    )
}

const MatchDetails = (props) => {
    const { detailDialog, setDetailDialog, insidePreData, revenue, value, loading } = props;
    let type = Number(value) + 2;
    const topPredictions = revenue?.predictionData?.top_predictions ? revenue.predictionData.top_predictions : []
    const leastPredictions = revenue?.predictionData?.least_predictions ? revenue.predictionData.least_predictions : []

    return (
        <>

            <Dialog open={detailDialog} onClose={() => setDetailDialog(false)}  >
                <div style={{ padding: "40px", minWidth: "450px" }}>
                    <center>
                        <h4>{`Total Incoming : ${insidePreData.total_incoming}`}</h4>
                        <h4>{`Total Outgoing : ${insidePreData.total_outgoing}`}</h4>
                        <h4>{`Total Profit : ${insidePreData.profit}`}</h4>
                        {!loading ?
                            <>
                                {type === 3 && revenue?.totalCount?.total_matched ? <h4>{`Total Matched Slots Count : ${Math.ceil(revenue?.totalCount?.total_matched)}`}</h4> : ""}
                                <hr></hr>
                                {topPredictions && topPredictions.length ?
                                    <>
                                        <h4>Top 5 Questions</h4>
                                        <Table sx={{ maxWidth: "300px", overflow: "scroll" }} >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">Prediction Id</TableCell>
                                                    <TableCell align="center">Question</TableCell>
                                                    {type === 3 ? <TableCell align="center">Matched count</TableCell> : ""}
                                                    <TableCell align="center">Revenue</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {topPredictions.map(preData => <TableRow key={topPredictions.prediction_id}>
                                                    <TableCell align='center'>{preData.prediction_id}</TableCell>
                                                    <TableCell align='center'>{preData.question_english}</TableCell>
                                                    {type === 3 ? <TableCell align='center'>{Math.ceil(preData.total_match_count)}</TableCell> : ""}
                                                    <TableCell align='center'>{preData.total_revenue}</TableCell>
                                                </TableRow>)}
                                            </TableBody>

                                        </Table>

                                        <hr></hr>
                                    </> : ""}
                                {leastPredictions && leastPredictions.length ?
                                    <>
                                        <h4>Least 5 Questions</h4>
                                        <Table sx={{ maxWidth: "300px", overflow: "scroll" }} >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">Prediction Id</TableCell>
                                                    <TableCell align="center">Question</TableCell>
                                                    {type === 3 ? <TableCell align="center">Matched count</TableCell> : ""}
                                                    <TableCell align="center">Revenue</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {leastPredictions.map(preData => <TableRow key={leastPredictions.prediction_id}>
                                                    <TableCell align='center'>{preData.prediction_id}</TableCell>
                                                    <TableCell align='center'>{preData.question_english}</TableCell>
                                                    {type === 3 ? <TableCell align='center'>{Math.ceil(preData.total_match_count)}</TableCell> : ""}
                                                    <TableCell align='center'>{preData.total_revenue}</TableCell>
                                                </TableRow>)}
                                            </TableBody>

                                        </Table>
                                    </> : ""}
                            </> : <CircularProgress></CircularProgress>}
                    </center>
                </div>
            </Dialog>

        </>
    )
}

const PredWiseDetails = (props) => {
    const { predDetailDialog, setPredDetailDialog, predWiseData, loading, value, downloadCSVPredWise, proPlayRunWiseData, runWiseDialog, setRunWiseDialog, runWiseData } = props;
    let type = Number(value) + 2;

    return (
        <>


            <Dialog open={predDetailDialog} onClose={() => setPredDetailDialog(false)} disableEnforceFocus={true}  >
                <div style={{ padding: "40px", minWidth: "450px" }}>


                    {!loading ?
                        <>
                            <div
                                onClick={() => downloadCSVPredWise()}

                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    width: "100px",
                                }}

                            >
                                Download CSV
                            </div>

                            <center>
                                <div>
                                    <h4>Prediction Wise Profit</h4>
                                    <hr></hr>
                                    {predWiseData && predWiseData.length ?
                                        <>

                                            <Table sx={{ maxWidth: "500px", overflow: "scroll" }} >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">Prediction Id</TableCell>
                                                        <TableCell align="center">Question</TableCell>
                                                        <TableCell align="center">Profit</TableCell>
                                                        {type === 4 ? <TableCell align="center">Run Wise</TableCell> : ""}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {predWiseData.map(preData => <TableRow key={preData._id}>
                                                        <TableCell align='center'>{preData._id}</TableCell>
                                                        <TableCell align='center'>{preData.question_english}</TableCell>
                                                        <TableCell align='center'>{preData.profit}</TableCell>
                                                        {type === 4 ? <TableCell align='center'>
                                                            
                                                          {/* <ProPlayRunWiseData runWiseDialog={runWiseDialog} setRunWiseDialog={setRunWiseDialog} value={value} loading={loading} runWiseData={runWiseData} predictionInfo={preData} proPlayRunWiseData={proPlayRunWiseData}></ProPlayRunWiseData> */}

                                                            <Button color='warning' disabled={!preData.is_over_under} onClick={() => proPlayRunWiseData(preData)}>View</Button>
                                                        
                                                        </TableCell> : ""}
                                                    </TableRow>)}
                                                </TableBody>

                                            </Table>

                                            <hr></hr>
                                        </>

                                        : ""}
                                </div>
                            </center>
                        </>

                        : <center> <CircularProgress></CircularProgress> </center>}

                </div>
            </Dialog>


        </>
    )
}

const ProPlayRunWiseData = (props) => {
    const { runWiseDialog, setRunWiseDialog, runWiseData, loading, value, predictionInfo, proPlayRunWiseData, downloadCSVRunWise } = props;
    let type = Number(value) + 2;


    return (
        <>

            <Dialog open={runWiseDialog} onClose={() => setRunWiseDialog(false)} disableEnforceFocus={true} >
                <div style={{ padding: "40px", minWidth: "450px" }}>
                    <SlArrowLeftCircle onClick={() => setRunWiseDialog(false)}></SlArrowLeftCircle>
                    {!loading ?
                        <>
                            <div style={{display:"flex", justifyContent:"end"}}>
                               <button
                                onClick={() => downloadCSVRunWise()}

                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    width: "170px",
                                }}

                            >
                                Download CSV
                                </button>
                                </div>

                            <center>
                                <div>
                                    <h4>Run Wise Data: {predictionInfo?._id}</h4>
                                    <h4> {predictionInfo?.question_english }</h4>
                                    <hr></hr>
                                    {runWiseData && runWiseData.length ?
                                        <>

                                            <Table sx={{ maxWidth: "500px", overflow: "scroll" }} >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">Option Id</TableCell>
                                                        <TableCell align="center">Runs</TableCell>
                                                        <TableCell align="center">Total Slot</TableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {runWiseData.map(preData => <TableRow key={preData._id}>
                                                        <TableCell align='center'>{preData._id.option_id}</TableCell>
                                                        <TableCell align='center'>{preData._id._id}</TableCell>
                                                        <TableCell align='center'>{preData.total_slot}</TableCell>
                                                    </TableRow>)}
                                                </TableBody>

                                            </Table>

                                            <hr></hr>
                                        </>

                                        : ""}
                                </div>
                            </center>
                        </>

                        : <center> <CircularProgress></CircularProgress> </center>}

                </div>
            </Dialog>

        </>
    )
}

